import {getRequest, URL_SERVER} from './../requests'


export async function getTransactions(token){
    try {
        return await getRequest(URL_SERVER + '/txs', token)
    } catch (error) {
        console.error(error);
    }
}